import React, {useEffect, useState, useContext} from 'react';
import {getNewsLabel} from './Data';
import {getLocalStorage, setLocalStorage} from './Utils';
import ApplicationContext from './ApplicationContext';
import newImage from "../assets/images/new.png";

const NavBar = (props) => {
	const [selection, setSelection] = useState();
	const [selectionStyle, setSelectionStyle] = useState("none");
	const data = useContext(ApplicationContext);

	useEffect(() => {
		let subDirCookieIndex = getLocalStorage("SUB_DIR_INDEX");
		// If it isn't already set, default it to the first entry in the list.
		if (!subDirCookieIndex) {
			subDirCookieIndex = 0;
			setLocalStorage("SUB_DIR_INDEX", 0);
		}

		// console.log(`DEBUG: NavBar - subDirCookieIndex - ${subDirCookieIndex}`);
		let newsLabel = getNewsLabel(parseInt(subDirCookieIndex), data.choicePairsList);
		setSelection(newsLabel?.length === 2 ? newsLabel[0] : null);
	}, [data.choicePairsList]);

	const doSelection = (e) => {
		e.preventDefault();
		if (selectionStyle === "block") {
			setSelectionStyle("none");
		}
		else {
			setSelectionStyle("block");
		}
	};

	const onSelectionChange = (index, entry) => {
		setSelection(entry.length === 2 ? entry[0] : null);
		setLocalStorage("SUB_DIR_INDEX", index);

		if (props.onClick) {
			props.onClick({index, keyword:entry[0], label:entry[0]});
		}
	};

	const [hover, setHover] = useState(Array(data.choicePairsList.length).fill(false));

	const handleMouseEnter = (e, index) => {
		e.preventDefault();
		let copyHover = Array(data.choicePairsList.length).fill(false);
		copyHover[index] = true;
		setHover(copyHover);
	};
  
	const handleMouseLeave = () => {
		let copyHover = Array(data.choicePairsList.length).fill(false);
		setHover(copyHover);
	};

	return (
		<div className="navbar">
			<ul>
				<li onClick={doSelection}>
					<div>{selection}</div>
					<div>(tap here to change)</div>
					<ul style={{display: selectionStyle }}>
						{data.choicePairsList.map((entry, index) => {
							return (
								<li style={{
									backgroundColor: hover[index] ? "#616060" : entry[1]?.backgroundColor,
									color: hover[index] ? "#fff" : entry[1]?.foregroundColor,
									opacity: entry[1]?.monetized === "1" ? 0.5 : 1
								}}
									onMouseEnter={(e) => handleMouseEnter(e, index)}
									onMouseLeave={handleMouseLeave}
									key={index}
									onClick={() => onSelectionChange(index, entry)}>
										{entry[0]}
										{entry[1].new === "1" && <img src={newImage} alt="" width={34}/>}
								</li>
							);
						})}
					</ul>
				</li>
			</ul>
		</div>
	);
}

export default NavBar;
